<template>
  <div class="flex h-screen overflow-hidden font-sans app-background">
    <!-- Single Sidebar Component -->
    <SidebarComponent
      v-if="showLayout"
      :is-open="isSidebarOpen"
      @close="isSidebarOpen = false"
    />

    <div class="flex flex-col flex-1 min-h-screen relative z-0">
      <NavbarComponent
        v-if="showLayout"
        @toggle-sidebar="isSidebarOpen = !isSidebarOpen"
      />

      <main class="flex-grow p-4 overflow-auto relative z-0">
        <router-view />
      </main>

      <FooterComponent v-if="showLayout" class="relative z-0" />
    </div>

    <!-- Mobile Backdrop -->
    <div
      v-if="isSidebarOpen"
      class="fixed inset-0 z-40 bg-black bg-opacity-50 md:hidden"
      @click="isSidebarOpen = false"
    />
  </div>
</template>


<script>
import NavbarComponent from '@/components/NavbarComponent.vue'
import SidebarComponent from '@/components/SidebarComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  name: 'AdminApp',
  components: {
    NavbarComponent,
    SidebarComponent,
    FooterComponent
  },
  data() {
    return {
      isSidebarOpen: false
    }
  },
  computed: {
    showLayout() {
      return this.$route.meta.requiresLayout !== false
    }
  },
  methods: {
    toggleSidebar() {
      console.log('Toggling sidebar. Current state:', this.isSidebarOpen);
    this.isSidebarOpen = !this.isSidebarOpen;
    }
  }
}
</script>
<style>
.app-background {
  background-color: #f1f6fa; /* Replace with your desired color */
  color: #1a1a1a;
}
</style>

